<template>
  <div id="ce-moves-list">
    <h2 class="title">Movimientos Recientes</h2>
    <p>La auditoría final de los cruces por el carril toma de 2-3 días hábiles, por lo que durante este período están sujetos a cambios.</p>
    <MoveListCeTable :crossings="list" />
  </div>
</template>

<script>
import MoveListCeTable from '@/components/MoveListCeTable'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MovesList',
  components: {
    MoveListCeTable
  },
  data () {
    return {
      showModalSentri: false,
      titleContent: 'CRUCES RECIENTES'
    }
  },
  computed: {
    ...mapState('crossings', ['list'])
  },
  methods: {
    ...mapActions('crossings', [
      'getCrossings'
    ])
  },
  beforeMount: function () {
    this.getCrossings().then(response => {
    }).catch(_ => {
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#ce-moves-list {
  text-align: left;
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color:$grey;
}
</style>
